module.exports = __webpack_public_path__ + "static/media/invitation.254fa789.jpeg";